import styled from 'styled-components';

export default styled.div`
  && {
    width: 100%;
    padding: 40px 65px;
    .※ {
      color: rgba(255, 0, 0, 1);
      height: 18px;
      width: 12px;
      margin-right: 4px;
    }
    .rec {
      width: 13px;
      height: 59px;
      background: #000000;
      border-radius: 10px 0 0 0;
      margin-right: 17px;
      margin-top: 5px;
    }
    .title {
      display: flex;
    }
    .textTitle {
      margin-top: 17px;
    }
    .form {
      padding: 53px 30px 40px 30px;
      margin-bottom: 20px;
      background-color: rgba(244, 244, 244, 1);
      .spaceLine {
        margin-bottom: 32px;
      }
    }
    .form1 {
      padding: 30px 30px 5px 30px;
      background-color: rgba(244, 244, 244, 1);
      margin-bottom: 20px;
      .l {
        border-right: 1px solid #000000;
        height: 30px;
      }
      .space1 {
        margin: 5px;
        height: 14px;
      }
      .space2 {
        margin: 0 10px 0 15px;
      }
    }
    .pt-5 {
      padding-top: 5px;
    }
    .bb-1 {
      .ant-form-item {
        margin-bottom: 0;
      }
      :first-child {
        border: rgba(244, 244, 244, 1);
      }
      border-top: 1px solid #dddddd;
      padding-top: 6px;
    }
    .itemCenter {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .disable {
      height: 30px;
      width: 100px;
      background-color: #dddddd;
    }
    .accessories {
      display: flex;
      align-items: center;
      .l {
        border-right: 0.5px solid #000000;
        height: 30px;
      }
      .space2 {
        margin: 0 10px;
      }
    }
    .mr-5 {
      margin-right: 5px;
    }
    .none {
      background-color: rgba(244, 244, 244, 1);
    }
    .mb-6px {
      margin-bottom: 6px;
    }
    .pl-10px {
      padding-left: 10px;
    }
    .m-5px {
      margin: 5px;
    }
    .form2 {
      padding: 30px;
      background-color: rgba(244, 244, 244, 1);
      margin-bottom: 20px;
      .l {
        border-right: 0.5px solid #000000;
        height: 30px;
        margin: 0 10px;
      }
    }
    .mb-24 {
      margin-bottom: 24px;
    }
    .submit {
      display: flex;
      align-items: center;
      flex-direction: column;
      margin-top: 30px;
      margin-bottom: 30px;
      .text {
        text-align: center;
        margin-bottom: 20px;
      }
      .btn {
        width: 240px;
        height: 60px;
      }
    }
    .error {
      background-color: rgba(255, 241, 240, 1);
      border: 1px solid rgba(255, 204, 199, 1);
      display: flex;
      justify-content: center;
      align-items: center;
      svg {
        color: rgba(255, 0, 0, 1);
      }
      p {
        margin: 7px 5px;
        color: rgba(255, 0, 0, 1);
      }
    }
    .ant-btn {
      :hover {
        background: white;
        border: 1px solid rgba(235, 164, 80, 1);
        color: rgba(235, 164, 80, 1);
      }
    }
    .ant-checkbox-group {
      display: flex;
      flex-direction: column;
      .ant-checkbox-group-item {
        padding-top: 10px;
        padding-bottom: 12px;
        border-bottom: 1px solid #dddddd;
        margin-right: 0;
        :last-child {
          border: none;
        }
      }
    }
    .pl-10px {
      padding-left: 10px;
    }
  }
`;
